const config = {
};

let extendConfig = {};
if (process.env.NODE_ENV === 'production') {
  /* ================================
   PRODUCTION
  ================================ */
  extendConfig = {
    api: 'https://app.letsbrief.com/api',
    socket: 'https://app.letsbrief.com',
    appHost: 'https://widget.letsbrief.com',
    appScript: 'https://widget.letsbrief.com/app/app.min.js',
    fontsPath: 'https://widget.letsbrief.com/fonts',
    filesPath: 'https://brief.imgix.net',
  };
} else {
  /* ================================
   DEVELOPMENT
  ================================ */
  extendConfig = {
    api: 'http://localhost:7000/api',
    socket: 'http://localhost:7000',
    appHost: 'http://localhost:3000/',
    appScript: 'http://localhost:3000/app/app.js',
    fontsPath: 'http://localhost:3000/fonts',
    filesPath: 'https://brief.imgix.net',
  };
}
Object.keys(extendConfig).forEach((key) => {
  config[key] = extendConfig[key];
});

export default config;
